<div class="header">
  <mat-icon (click)="goBack()" class="back-arrow">arrow_back</mat-icon>
  <span>Delete Account</span>
</div>
<div class="content container mt-4">
  <p class="alert alert-warning">
    Deleting your account will permanently remove all of your data from our
    servers. This action cannot be undone.
  </p>
  <p>
    If you would like to proceed, please enter your email address below and
    click the "Delete Account" button.
  </p>
  <form (submit)="onDeleteAccount()" class="needs-validation" novalidate>
    <div class="mb-3">
      <label for="email" class="form-label">Email Address:</label>
      <input
        type="email"
        id="email"
        name="email"
        class="form-control"
        required
      />
      <div class="invalid-feedback">Please enter a valid email address.</div>
    </div>
    <button type="submit" class="btn btn-danger">Delete Account</button>
  </form>
</div>
